<template>
  <div class="builder-page-modules">
    <div class="mt-6">
      <BuilderPageModulesForm
        title="Result page"
        class="page-modules-result"
        v-model="pageModulesListResult"
      />
    </div>
    <div class="mt-6">
      <BuilderPageModulesForm
        title="End page"
        class="page-modules-end"
        v-model="pageModulesListEnd"
      />
    </div>
    <div class="mt-6">
      <BuilderPageModulesForm
        title="Chart page"
        class="page-modules-page"
        v-model="pageModulesListChart"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import { TranslationHandler } from '../../mixins/translation-handler'
import { PageModule, PageModuleData } from '../../types'
import BuilderPageModulesForm from './BuilderPageModulesForm.vue'

@Component({
  components: { BuilderPageModulesForm }
})
export default class BuilderPageModules extends Mixins(TranslationHandler) {
  get pageModulesListResult (): PageModule<PageModuleData>[] {
    return this.$store.getters.pageModulesListResult
  }

  set pageModulesListResult (list: PageModule<PageModuleData>[]) {
    this.$store.commit('SET_PAGE_MODULES_LIST_RESULT', list)
  }

  get pageModulesListEnd (): PageModule<PageModuleData>[] {
    return this.$store.getters.pageModulesListEnd
  }

  set pageModulesListEnd (list: PageModule<PageModuleData>[]) {
    this.$store.commit('SET_PAGE_MODULES_LIST_END', list)
  }

  get pageModulesListChart (): PageModule<PageModuleData>[] {
    return this.$store.getters.pageModulesListChart
  }

  set pageModulesListChart (list: PageModule<PageModuleData>[]) {
    this.$store.commit('SET_PAGE_MODULES_LIST_CHART', list)
  }
}
</script>

<style scoped></style>
